import script from "./Recruits.vue?vue&type=script&setup=true&lang=js"
export * from "./Recruits.vue?vue&type=script&setup=true&lang=js"

import "./Recruits.vue?vue&type=style&index=0&id=5347acd3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5347acd3"]])

export default __exports__